import {Card, Divider, Stack, Tooltip, Typography} from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import Iconify from "../../components/Iconify";
import {AnimatePresence, motion} from "framer-motion";
import {
    COUNTRY_BORDERS,
    DIRECTION_NAME,
    INVOICE_TYPE,
    PAYMENT_TYPE,
    ROLES_CAN_ISSUE_TICKETS,
    SERBIA_ALPHA_2_CODE
} from "../../constants";
import {useFormContext, useWatch} from "react-hook-form";
import {getIniLoggedUser, getSessionOperator} from "../../helper/session";
import {useSnackbar} from "notistack";
import * as React from "react";
import {useEffect, useLayoutEffect, useState} from "react";
import moment from "moment";
import {getCommentsAPI, getItinerariesLinkedAPI} from "../../api/trip";
import Comments from "./Comments";
import {getTrafficType} from "../../helper/homePage";
import {useLocales} from "../../locales";
import {useSelector} from "../../redux/store";
import {getCommentAPI} from "../../api/lines";
import {isWithinTwoHours} from "../../helper/timeCheck";
import {invoiceTotalAmount} from "../../helper/invoice/allCalculations";
import {getServiceDistanceInKm} from "./helper";
import {postTicketReleaseAPI} from "../../api/tickets";
import TripCardHeader from "./TripCardHeader";
import TripCardInfo from "./TripCardInfo";
import TripActionButtons from "./TripActionButtons";
import TripExpandedDetails from "./TripExpandedDetails";
import TripDialogs from "./TripDialogs";
import {passengerModel} from "./models/passenger";
import {onSubmitWithOppositeSplit} from "./utils/onSubmitWithOppositeSplite";

export default function Results({
                                    printedInvoices,
                                    setPrintedInvoices,
                                    hoveredRef,
                                    index,
                                    onSuccess,
                                    data,
                                    directionType,
                                    handleSubmit,
                                    onSubmit,
                                    handleOpenPaymentDialog,
                                    setMakeReservation
                                }) {
    const {homeArrStations} = useSelector(state => state.stations);
    const {canSellExpiredDepartures, expiredDepartureMinutesLimit} = useSelector(state => state.userSettings);
    const {settings} = useSelector(state => state.settings);
    const currentTime = moment.tz("Europe/Belgrade").format("YYYY-MM-DD HH:mm:ss");
    const OPERATOR = getSessionOperator()
    const {enqueueSnackbar} = useSnackbar();
    const {translate} = useLocales();
    const [showVerificationDialog, setShowVerificationDialog] = useState({
        open: false,
        data: null
    })
    const [showPlatformDialog, setShowPlatformDialog] = useState(false);
    const [departureTimeFromSpot, setDepartureTimeFromSpot] = useState()
    const [lineComment, setLineComment] = useState()
    const [loadingItinerants, setLoadingItinerants] = useState(false)
    const [showItinerer, setShowItinerer] = useState({open: false, data: null})
    const {
        setValue,
        control,
        getValues
    } = useFormContext();
    const [commentsProps, setCommentsProps] = useState({
        loading: false,
        comments: []
    })
    const isTripExpired = () => {
        if (data.canceled) return true;
        const departureTime = moment.tz(data.departureTripTime, "YYYY-MM-DD HH:mm:ss", "Europe/Belgrade");
        const now = moment.tz("Europe/Belgrade");
        if (departureTime.isAfter(now)) return false;
        if (!canSellExpiredDepartures) return true;
        const minutesLimit = expiredDepartureMinutesLimit || 0;
        const minutesSinceDeparture = now.diff(departureTime, 'minutes', true);
        return minutesSinceDeparture > minutesLimit;
    };
    const isDesktop = useResponsive("up", "lg");

    useLayoutEffect(() => {
        setCommentsProps(prevState => ({
            ...prevState,
            loading: true
        }))

        getCommentsAPI(data.tripId, moment.utc(data.departureTripTime).format("YYYY-MM-DD")).then(({data}) => {
            setCommentsProps(prevState => ({
                ...prevState,
                comments: data
            }))
        }).catch(reason => {
            console.error("getCommentsAPI", reason);
            // enqueueSnackbar("Nije moguće učitati komentare", {variant: "error"})
        }).finally(() => {
            setCommentsProps(prevState => ({
                ...prevState,
                loading: false
            }))
        })
    }, []);


    const isOpenIndex = useWatch({
        control,
        name: 'isOpenIndex'
    })

    const hovered = useWatch({
        control,
        name: 'hovered'
    })

    const dateFrom = useWatch({
        control,
        name: 'dateFrom'
    })
    const returnDate = useWatch({
        control,
        name: 'returnDate'
    })

    const actions = useWatch({
        control,
        name: 'actions'
    })

    const showInfoDialog = useWatch({
        control, name: "showInfoDialog"
    })

    const showPriceListDialog = useWatch({
        control, name: "showPriceListDialog"
    })

    const showReturnDialog = useWatch({
        control, name: "showReturnDialog"
    })

    const returnTrip = useWatch({
        control, name: "returnTrip"
    })

    useEffect(() => {
        if (isOpenIndex !== -1) {
            // const lineID = data.lineId
            getItinerariesLinkedAPI(data.tripId, getValues("dateFrom"), data?.linkId).then(({data}) => {
                const foundTime = findStationAndCalculateTimes(data)
                if (foundTime) {
                    setDepartureTimeFromSpot(foundTime)
                } else {
                    if (departureTimeFromSpot) {
                        setDepartureTimeFromSpot()
                    }
                }
                // getCommentAPI(lineID).then(response => {
                //     setLineComment(response?.data || null)
                // })
            }).catch(e => {
                console.error(e, "Error fetching Line Stations");
            });
        }
    }, [isOpenIndex]);

    // Dok je kartica otvorena, roditelj prikazuje samo taj polazak i njegov index resetuje na 0,
    // pa se otvorenost ne sme proveravati poređenjem sa index-om.
    const isExpanded = () => getValues('isOpenIndex') !== -1;

    const handleKeyboardPress = e => {
        if (e.key === 'F6') {
            e.preventDefault();
            const flag = isWithinTwoHours(data.departureTripTime);
            if (flag) {
                return enqueueSnackbar("Nije moguće uraditi rezervaciju 2h pred put!", {variant: "warning"})
            }
            if (isExpanded()) {
                setMakeReservation(true);
                setValue("reservationData", data)
            }
        }
        if (e.key === 'F4') {
            e.preventDefault();
            if (data.externalSale || isTripExpired()) {
                return enqueueSnackbar("Nije moguće uraditi overu!", {variant: "warning"})
            }
            if (isExpanded()) {
                setShowVerificationDialog({open: true, data});
            }
        }
        if (e.altKey && e.key.toLowerCase() === 'g') {
            if (!isExpanded()) return;
            if (isTripExpired()) {
                return enqueueSnackbar("Polazak je istekao!", {variant: "warning"})
            }
            e.preventDefault();
            validateAndSubmit(data, handleSubmit((props) =>
                onSubmitWithOppositeSplit(props, PAYMENT_TYPE.cash, INVOICE_TYPE.normal).then(onSubmit)
            ));
        }

        if (e.altKey && e.key.toLowerCase() === 'k') {
            if (!isExpanded()) return;
            if (isTripExpired()) {
                return enqueueSnackbar("Polazak je istekao!", {variant: "warning"})
            }
            e.preventDefault();
            validateAndSubmit(data, handleSubmit((props) =>
                onSubmitWithOppositeSplit(props, PAYMENT_TYPE.card, INVOICE_TYPE.normal).then(onSubmit)
            ));
        }
    }

    useEffect(() => {
        window.addEventListener('keydown', handleKeyboardPress);
        return () => {
            window.removeEventListener('keydown', handleKeyboardPress)
        }

    }, [])

    useEffect(() => {
        if (isOpenIndex !== -1) {

            window.scrollTo({top: 0, behavior: 'smooth'});


            setTimeout(() => {
                window.scrollBy({top: 205, behavior: 'smooth'});
            }, 300);
        }
    }, [isOpenIndex]);


    const trafficType = getTrafficType();
    const activeAction = actions?.find(action => action?.trafficType === trafficType?.id);

    function validatePassengerPrivileges(passengers) {
        return passengers.every(passenger => {
            const requiresValidation = passenger.discountPCT?.documentValidation;
            if (requiresValidation) {
                return passenger.havePrivilege === true;
            }
            return true;
        });
    }

    const validateAndSubmit = (row, func) => {
        if (!validatePassengerPrivileges(passengers)) return enqueueSnackbar("Privilegovani putnici moraju imati izabranu povlasticu", {variant: "info"})
        if (row.requiresReturnDate === true && returnDate === null && directionType === DIRECTION_NAME[1]) {
            return enqueueSnackbar("Izaberite datum povratka", {variant: "warning"});
        }
        const isInternational = row?.arrCountryCode !== SERBIA_ALPHA_2_CODE || row?.depCountryCode !== SERBIA_ALPHA_2_CODE;
        if (settings?.requireNamesForInternationalTicket && isInternational) {
            const missing = (passengers || []).some(p => !p?.name?.trim() || !p?.lastName?.trim());
            if (missing) {
                return enqueueSnackbar("Za međunarodne karte obavezno je popuniti ime i prezime za svakog putnika", {variant: "warning"});
            }
        }
        func();
    }


    const passengers = useWatch({
        control,
        name: 'passengers'
    })

    const defaultServices = useWatch({
        control,
        name: 'defaultServices'
    })

    const {currentTaxRates} = useSelector(((state) => state.taxCore));

    const distanceInKm = getServiceDistanceInKm(data);
    const startStationId = getValues("startStation")?.id;
    const filteredServices = (defaultServices || []).filter(service =>
        (!Array.isArray(service.includeOnStations) || service.includeOnStations.includes(startStationId)) &&
        (service.distanceFromKm == null && service.distanceToKm == null ||
            (distanceInKm != null &&
                (service.distanceFromKm == null || distanceInKm >= service.distanceFromKm) &&
                (service.distanceToKm == null || distanceInKm < service.distanceToKm)))
    );
    const calculated = invoiceTotalAmount({
        price: data?.priceOneWay || 0,
        returnPrice: data?.priceReturnTicket || 0,
        priceMonthly: data?.priceMonthly || 0,
        passengers: passengers,
        saleAction: actions[0], // ovo treba da bude objekat jer samo jedna moze biti
        services: filteredServices,
        directionType: directionType,
        currentTaxRates: currentTaxRates,
        externalSale: data?.externalSale,
        isInternational: data?.arrCountryCode !== "RS"
    })

    const doCancelation = () => {
        const currentTicketIDS = passengers
            ?.filter(p => p?.id != null)
            .map(p => p.id);
        if (currentTicketIDS?.length > 0) {
            // Ako postoje karte za otkazivanje
            postTicketReleaseAPI(currentTicketIDS);
        }
    }
    const isSoldOut = data.freeSeats != null && data.freeSeats <= 0;

    const handleCardClick = () => {
        {
            {
                doCancelation()
                setValue("linkId", typeof data?.linkId === "number" ? data?.linkId : null)
                setValue("operatorId", data.operatorId)
                setValue("selectedTripId", data.tripId)
                setValue("passengersCount", 1)
                setValue("passengers", [passengerModel])
                if (directionType === DIRECTION_NAME[1] && data.externalSale === true && !returnTrip) {
                    setValue("showReturnDialog", true);
                    setValue('isOpenIndex', index);
                    setValue('invoiceLine', data)
                    return;
                }
                // if (!ROLES_CAN_ISSUE_TICKETS.includes(OPERATOR.group)) {
                //     setLoadingItinerants(true)
                //     getItinerariesLinkedAPI(data.tripId, getValues("dateFrom"), data?.linkId).then(({data}) => {
                //         setShowItinerer({open: true, data: data})
                //     }).catch(reason => {
                //         console.error("getItinerariesLinkedAPI", reason)
                //         enqueueSnackbar(translate("error"), {variant: "error"})
                //     }).finally(() => {
                //         setLoadingItinerants(false)
                //     })
                //     return;
                // }

                if (isTripExpired()) {
                    return
                }

                if (
                    (data?.arrCountryCode !== SERBIA_ALPHA_2_CODE || data?.depCountryCode !== SERBIA_ALPHA_2_CODE)
                    && (data?.depBorderDistance <= 0 ||
                        data?.arrBorderDistance <= 0) && data?.operatorId === getIniLoggedUser()?.id) {
                    enqueueSnackbar("Molimo Vas podesite udaljenost stanice od graničnog prelaza", {variant: "warning"})
                } else {
                    if (isOpenIndex !== index) {
                        if (isOpenIndex !== -1) {
                            setValue('isOpenIndex', -1);
                        } else {
                            setValue('isOpenIndex', index);
                        }

                        const foundStation = homeArrStations.find(f => f.id === data?.arrStationId)
                        if (foundStation) {
                            setValue('endStation', foundStation)

                        }
                        setValue('invoiceLine', data)
                        if (activeAction?.amount > 0) {
                            setValue('discountPCT', {
                                name: activeAction?.salesActionType?.name,
                                discountPCT: activeAction?.amount
                            })
                        }
                    } else {
                        setValue("returnDate", null)
                        setValue("returnTrip", null)
                        setValue('isOpenIndex', -1);
                    }
                }
            }
        }
    };

    // TODO dodati proveru da li postoji povratak?
    return (
        <div style={{position: "relative"}}>
            {activeAction &&
                <Tooltip title={activeAction?.salesActionType?.name || ""}>
                    <Iconify
                        width={30}
                        icon="mdi:discount"
                        sx={{
                            zIndex: 999,
                            top: -10,
                            left: -10,
                            position: "absolute",
                            color: "primary.main"
                        }}/>
                </Tooltip>
            }
            <Stack
                ref={hovered === index ? hoveredRef : null}
                onClick={handleCardClick}
                direction="row"
                sx={{
                    border: hovered === index ? '4px dashed #6DABE4' : 'none',
                    borderRadius: 2,
                    mt: 2,
                    position: 'relative'
                }}>
                <Card sx={{
                    border: data.canceled ? "2px dashed red" : null,
                    p: 2,
                    width: '100%',
                    background: hovered === index ? '#e7e7e7' : 'none',
                    "&:hover": {
                        cursor: loadingItinerants ? "not-allowed" : "pointer",
                        background: "#f0f1f2",
                    }
                }}>
                    {isSoldOut && (
                        <Typography
                            variant="h3"
                            sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                letterSpacing: 1.2,
                                transform: "translate(-50%, -50%) rotate(-20deg)",
                                color: "rgba(255, 0, 0, 0.85)",
                                fontWeight: 700,
                                textTransform: "uppercase",
                                whiteSpace: "nowrap",
                                pointerEvents: "none",
                                zIndex: 100
                            }}
                        >
                            Rasprodato
                        </Typography>
                    )}
                    <TripCardHeader
                        data={data}
                        hovered={hovered}
                        index={index}
                        hoveredRef={hoveredRef}
                    />
                    {data.canceled &&
                        <Typography textAlign="center" variant="subtitle2"
                                    color="darkRed">({data.canceledNote})</Typography>}
                    <Comments routeComment={data.routeComment} commentInternal={data.commentInternal}
                              allowedViewers={data.allowedViewers}
                              loading={commentsProps.loading}/>
                </Card>
                <Divider
                    orientation={isDesktop ? 'vertical' : 'horizontal'}
                    flexItem
                    sx={{borderRightWidth: 4, borderStyle: 'dashed'}}
                />
                <TripCardInfo
                    data={data}
                    directionType={directionType}
                    calculated={calculated}
                    returnTrip={returnTrip}
                    hovered={hovered === index}
                />
            </Stack>
            <AnimatePresence>
                {(isOpenIndex !== -1 &&
                    <motion.div
                        key="card"
                        initial={{opacity: 0, y: -20, height: 0}}
                        animate={{opacity: 1, y: 0, height: "auto"}}
                        exit={{opacity: 0, y: -20, height: 0}}
                        transition={{duration: 0.3}}
                        sx={{marginTop: 16}}>
                        <TripActionButtons
                            data={data}
                            directionType={directionType}
                            currentTime={currentTime}
                            OPERATOR={OPERATOR}
                            setValue={setValue}
                            getValues={getValues}
                            translate={translate}
                            enqueueSnackbar={enqueueSnackbar}
                            setShowVerificationDialog={setShowVerificationDialog}
                            setShowPlatformDialog={setShowPlatformDialog}
                            setShowItinerer={setShowItinerer}
                            setLoadingItinerants={setLoadingItinerants}
                            getItinerariesLinkedAPI={getItinerariesLinkedAPI}
                            setMakeReservation={setMakeReservation}
                        />
                        {ROLES_CAN_ISSUE_TICKETS.includes(OPERATOR.group) &&<TripExpandedDetails
                            data={data}
                            returnTrip={returnTrip}
                            currentTime={currentTime}
                            directionType={directionType}
                            onSubmit={onSubmit}
                            onSuccess={onSuccess}
                            enqueueSnackbar={enqueueSnackbar}
                            OPERATOR={OPERATOR}
                            handleOpenPaymentDialog={handleOpenPaymentDialog}
                            translate={translate}
                        />}
                    </motion.div>
                )}
            </AnimatePresence>
            <TripDialogs
                printedInvoices={printedInvoices}
                setPrintedInvoices={setPrintedInvoices}
                data={data}
                onSuccess={onSuccess}
                showVerificationDialog={showVerificationDialog}
                showItinerer={showItinerer}
                showPlatformDialog={showPlatformDialog}
                showReturnDialog={showReturnDialog}
                showInfoDialog={showInfoDialog}
                showPriceListDialog={showPriceListDialog}
                setValue={setValue}
                setShowVerificationDialog={setShowVerificationDialog}
                setShowItinerer={setShowItinerer}
                setShowPlatformDialog={setShowPlatformDialog}
            />

        </div>
    )
}

export const findFlag = (data) => {
    if (!data) {
        return ""
    }
    let flag = `ic_serbia`
    for (let i = 0; i < COUNTRY_BORDERS.length; i++) {
        if (COUNTRY_BORDERS[i].name.includes(data.toUpperCase())) {
            flag = COUNTRY_BORDERS[i].icon
            break;
        }
    }
    return flag ? `/assets/icons/flags/${flag}.svg` : ""
}

function findStationAndCalculateTimes(objects) {
    for (let i = 0; i < objects.length; i++) {
        const obj = objects[i];

        if (obj.station.id === 1645) {
            if (i === 0) {
                return undefined;
            } else {
                const firstObj = objects[0];
                const currentObj = objects[i];

                return {
                    realDepTime: firstObj.tripDepartureTime,
                    arrTime: addTimes(firstObj.tripDepartureTime, currentObj.departureTime)
                };
            }
        }
    }

    return undefined;
}

function addTimes(time1, time2) {
    const [hours1, minutes1, seconds1] = time1.split(':').map(Number);
    const [hours2, minutes2, seconds2] = time2.split(':').map(Number);

    let seconds = seconds1 + seconds2;
    let minutes = minutes1 + minutes2 + Math.floor(seconds / 60);
    let hours = hours1 + hours2 + Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;
    hours = hours % 24;

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
